var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('video-background',{staticStyle:{"height":"100vh"},attrs:{"src":"/bg_loop.mp4","poster":"/bg_img.jpg"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }